<template>
    <div class="information">
        <Commondtitle title="信息公告" />
        <div class="in_content">
            <div v-if="nodata" class="in_co_ul">
                <ul>
                    <li
                        v-for="(item,index) in dataArr"
                        :key="index"
                        @click="goRoute(item.fmessageId)">
                        <div class="le_data">
                            <p><span>{{ item.fupdateTime2 }}</span><br>{{ item.fupdateTime3 }}</p>
                        </div>
                        <div class="le_title">
                            <p class="le_t_title">{{ item.fmessageTitle }}</p>
                            <p class="le_t_des" v-html="item.fmessageContent"></p>
                        </div>
                        <div class="le_company">
                            皓景环境技术有限公司
                        </div>
                    </li>
                </ul>
                <div class="le_div">
                    <el-button
                            v-if="nomoredata"
                            class="le_btn"
                            :loading="false"
                            type="success"
                            @click="getMoreData"
                            plain>查看更多
                        <i class="el-icon-sort-down el-icon--right"></i>
                    </el-button>
                    <p v-else class="nomore_data">暂无更多信息公告</p>
                </div>
            </div>
            <p v-else>暂无信息公告！</p>
        </div>
    </div>
</template>

<script>
    import Commondtitle from '../Commondtitle'
    import axios from '../../assets/js/baseaxios'
    export default {
        name: "information",
        data(){
            return{
                nodata: false, //true 有数据 fasle 无
                nomoredata: true, // true 有更多数据 false无
                current: 5, //当前查询条数
                dataArr: [],
            }
        },
        mounted(){
            this.getData()
        },
        methods:{
            getData(){
              axios.get(`/api/message?page=1&limit=${this.current}`).then(res=>{
                  if(res.data.success){
                      let items = res.data.items
                      if(items.length === 0){
                          this.nodata = false //无数据
                          return
                      }
                      if(res.data.total <= this.current){
                          this.nomoredata = false
                      }else{
                          this.nomoredata = true
                      }
                      items.forEach(btn=>{
                          let data = new Date(btn.fupdateTime.replace(/-/g,'/'))
                          let str = this.buwei((data.getMonth() + 1)) + '/' + data.getDate()
                          let str2 = data.getFullYear() + '年'
                          btn.fupdateTime2 = str
                          btn.fupdateTime3 = str2
                      })
                      this.dataArr = items
                      this.nodata = true
                  }else{
                      this.$message.warning(res.data.msg)
                  }
              })
            },
            getMoreData(){
                this.current += 5
                this.getData()
            },
            goRoute(val){
                this.$router.push({name: 'detail', query:{id: val, name: 'info'}})
            },
            buwei(val){
                if(val < 10) return '0' + val
                return val
            }
        },
        components:{
            Commondtitle
        }
    }
</script>

<style scoped>
    .information{
        width: 100%;
    }
    .in_content{
        position: relative;
        width: 1100px;
        min-height: 400px;
        margin: 0 auto;
    }
    .in_content>p{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #999;
        font-size: 14px;
        line-height: 19px;
    }
    .in_co_ul ul{
        padding-top: 10px;
        padding-bottom: 40px;
    }
    .in_co_ul ul li{
        display: flex;
        margin-bottom: 30px;
        height: 58px;
        align-content: center;
        cursor:pointer;
    }
    .in_co_ul li .le_data{
        position: relative;
        width: 58px;
        min-width: 58px;
        height: 58px;
        background-color: #00B76B;
        font-size: 12px;
        color: #fff;
        margin-right: 30px;
    }
    .in_co_ul li .le_data p{
        position: absolute;
        top: 50%;
        width: 100%;
        line-height: 16px;
        transform: translateY(-50%);
        text-align: center;
        font-size: 12px;
    }
    .in_co_ul li .le_data p span{
        font-size: 16px;
    }
    .in_co_ul li .le_title{
        width: 680px;
        margin-right: 30px;
    }
    .in_co_ul li .le_title .le_t_title{
        color: #333;
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 10px;
    }
    .in_co_ul li .le_title .le_t_des{
        width: 100%;
        color: #999;
        height: 19px;
        line-height: 19px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .in_co_ul li .le_company{
        width: 370px;
        text-align: right;
        line-height: 58px;
        color: #999;
        font-size: 14px;
    }
    .in_co_ul .le_div{
        text-align: center;
        margin-bottom: 100px;
    }
    .nomore_data{
        color: #999;
        font-size: 14px;
        line-height: 19px;
    }
    .el-button--success.is-plain{
        border-color: #00B76B;
        color: #00B76B;
        background: none;
    }
    .el-button--success.is-plain:focus, .el-button--success.is-plain:hover{
        background: #00B76B;
        border-color: #00B76B;
        color: #fff
    }
</style>
